import { cva } from "class-variance-authority";

export const inputContainerStyles = cva(
  [
    "h-11 p-3",
    "flex w-full cursor-text items-center gap-2 rounded-lg text-sm",
    "data-[invalid=true]:border-error-50 data-[invalid=true]:focus-within:shadow-input-error",
    "data-[warning=true]:border-warning-70 data-[warning=true]:focus-within:shadow-input-warning",
    "data-[disabled=true]:cursor-not-allowed",
  ],
  {
    variants: {
      variant: {
        outline:
          "border border-neutral-80 bg-white data-[disabled=true]:bg-neutral-95 data-[disabled=true]:text-neutral-70",
        blank:
          "h-fit! border-none! bg-transparent p-0! shadow-none! data-[disabled=true]:bg-transparent data-[disabled=true]:text-neutral-80",
      },
      color: {
        primary:
          "focus-within:border-primary-80 focus-within:shadow-input data-[disabled=true]:focus-within:border-neutral-80 data-[disabled=true]:focus-within:shadow-none",
        secondary:
          "focus-within:border-neutral-80 focus-within:shadow-input-secondary data-[disabled=true]:focus-within:border-neutral-80 data-[disabled=true]:focus-within:shadow-none",
      },
    },
  }
);

export const inputStyles = cva(
  [
    "w-full border-none p-0 text-sm text-neutral-10 focus-visible:ring-0 focus-visible:outline-hidden",
    "placeholder:text-neutral-70 read-only:cursor-default disabled:cursor-not-allowed",
  ],
  {
    variants: {
      variant: {
        outline:
          "bg-white placeholder:text-neutral-70 disabled:bg-neutral-95 disabled:text-neutral-50 disabled:placeholder:text-neutral-70",
        blank: "bg-transparent disabled:bg-transparent disabled:text-neutral-50 disabled:placeholder:text-neutral-80",
      },
    },
  }
);
